module.exports = __webpack_public_path__ + "img/sargazo-logohome.559c2497.jpg";